import { render, staticRenderFns } from "./MerchantSettlement.vue?vue&type=template&id=656e5d06&"
import script from "./MerchantSettlement.vue?vue&type=script&lang=js&"
export * from "./MerchantSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports